import { createApi } from "redux-future-middleware";
import { requestApi } from "core/api";
import * as types from "./types";

export const createToken = createApi({
  name: types.CREATE_TOKEN,
  request: ({ bookingId }) =>
    requestApi({
      path: `/insiders/call/${bookingId}/create-client-token/`,
      method: "GET"
    })
});



// WEBPACK FOOTER //
// ./src/modules/calling/api.js